// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { miniCartLineStyles } from "@rpsc/App/Components/MiniCart/MiniCartLineCard";
import Trash from "@rpsc/XDL/Icons/IconTrash";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, ellipsis } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

miniCartLineStyles.cartLine = {
    css: css`
        display: grid;
        grid-template-columns: 91px 1fr 16px;
        position: relative;
        gap: 12px;
    `,
};

miniCartLineStyles.imageWrapper = {
    css: css`
        grid-column: 1 / 2;
        position: relative;
        &,
        ${TypographyStyle} {
            display: flex;
            align-items: flex-start;
        }
        .tooltip-container {
            position: absolute;
            padding: 5px 4px;
            background-color: ${color("common.white", 0.66)};
        }
    `,
};

miniCartLineStyles.cartLineImage = {
    width: "91px",
    height: "91px",
    css: css`
        border: 1px solid ${color("common.border")};
        border-radius: 2px;
        max-height: 100%;
        max-width: 100%;
        border-radius: 4px;
        overflow: hidden;
        img {
            height: auto;
        }
    `,
};

miniCartLineStyles.detailsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        grid-column: 2 / 3;
    `,
};

miniCartLineStyles.lineDescription = {
    color: "common.black",
    typographyProps: {
        size: 14,
        weight: fontConfig.weight.bold,
        lineHeight: "17px",
        css: css`
            letter-spacing: 0;
            ${ellipsis(2)}
        `,
    },
};

miniCartLineStyles.qtyAndPriceWrapper = {
    css: css`
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    `,
};

miniCartLineStyles.qtyContainer = {
    css: css`
        display: flex;
        flex: 1;
    `,
};

miniCartLineStyles.basicProductPriceStyles = {
    priceWrapper: {
        css: css`
            display: flex;
            gap: 4px;
        `,
    },
    price: {
        priceText: {
            css: css`
                font-size: 16px;
                line-height: 22px;
                margin: 0;
            `,
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                mergeCss: true,
                weight: fontConfig.weight.regular,
                size: 12,
                css: css`
                    letter-spacing: 0;
                    line-height: 17px;
                `,
            },
        },
        callForPriceText: {
            css: css`
                &&& {
                    font-size: 16px;
                }
            `,
        },
    },
};

miniCartLineStyles.removeCartLineLink = {
    icon: {
        iconProps: {
            src: Trash,
            size: 16,
            color: "text.link",
            css: css`
                &,
                svg {
                    width: 14px;
                    &:hover {
                        color: ${color("common.ui8")};
                    }
                }
            `,
        },
    },
    css: css`
        grid-column: 3 / 4;
        align-items: start;
        height: fit-content;
    `,
};

miniCartLineStyles.errorMessagesWrapper = {
    css: css`
        width: 100%;
    `,
};

miniCartLineStyles.loginMessage = {
    size: 10,
    lineHeight: "11px",
    color: "common.ui6",
    css: css`
        ${wrapInContainerStyles}
        display: inline;
        flex: 1;
    `,
};

miniCartLineStyles.alertWarningIconStyles = {
    size: 14,
    color: "warning",
};

miniCartLineStyles.warningToolTip = {
    mergeCss: true,
    iconProps: {
        size: 14,
    },
    cssOverrides: {
        tooltipClickable: css`
            margin: 0;
        `,
        tooltipWrapper: css`
            margin-top: 2px;
        `,
    },
};

miniCartLineStyles.priceContainer = {
    css: css`
        display: flex;
        gap: 4px;
        flex: 1;
    `,
};
